import Parse from "parse/dist/parse.min.js";
import { handleParseError } from "../../lib/Errors";
import { APP_SHOW_MODULE_ANWESENHEIT } from "@/lib/config/AppConfigurations";

let localSubscription = undefined;

function createSubscription(store) {
	if (APP_SHOW_MODULE_ANWESENHEIT == "true") {
		let presenceQuery = new Parse.Query("Presence");
		presenceQuery
			.notEqualTo("deleted", true)
			.find()
			.then((results) => {
				store.dispatch("presence/set", results);
			})
			.catch((error) => {
				handleParseError(error);
				console.log(error);
			});
		presenceQuery.subscribe().then((subscription) => {
			localSubscription = subscription;

			subscription.on("create", (object) => {
				store.dispatch("presence/insert", object);
			});
			subscription.on("update", (object) => {
				store.dispatch("presence/replace", object);
			});
			subscription.on("enter", (object) => {
				store.dispatch("presence/insert", object);
			});
			subscription.on("leave", (object) => {
				store.dispatch("presence/delete", object);
			});
			subscription.on("delete", (object) => {
				store.dispatch("presence/delete", object);
			});
			subscription.on("close", () => {});
			subscription.on("error", (error) => {
				console.log("presence subscription error", error);
			});
		});
	}
}

export default function createPresenceSubscription() {
	return (store) => {
		if (store.state.currentUser) {
			createSubscription(store);
		}
		store.subscribe((mutation) => {
			if (mutation.type === "SET_CURRENT_USER") {
				if (localSubscription) {
					localSubscription.unsubscribe();
				}
				if (store.state.currentUser) {
					createSubscription(store);
				}
			}
		});
	};
}
